import { render } from "./ReasonSelectionManager.vue?vue&type=template&id=085a7f9c"
import script from "./ReasonSelectionManager.vue?vue&type=script&lang=js"
export * from "./ReasonSelectionManager.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__